import {
  Box,
  Stack,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Skeleton,
} from '@mui/material';
import { useLocalization } from '@/hooks/useLocalization';

export type InvitationType = 'default' | 'custom' | 'saved';

type Props = {
  value: InvitationType;
  hasSavedOptions: boolean;
  loading: boolean;
  onUseDefault: () => void;
  onUseCustomized: () => void;
  onUseSaved: () => void;
};

const InvitationTypeSelector = ({
  value,
  hasSavedOptions,
  loading,
  onUseDefault,
  onUseCustomized,
  onUseSaved,
}: Props) => {
  const { t } = useLocalization();
  return (
    <Stack gap={2}>
      <Box>
        <Typography
          variant='h6'
          sx={{ mb: 1.5 }}
        >
          {t(
            'bulkInvite.whichInvitation',
            'What invitation do you want to use?',
          )}
        </Typography>
        <Typography
          variant='body2'
          color='text.secondary'
          sx={{ mb: 1.5 }}
        >
          {t(
            'bulkInvite.inviteAppliesAll',
            'All invites to clients will use the selected invitation',
          )}
        </Typography>
        {loading ? (
          <Stack
            gap={1}
            sx={{ mt: 0.5 }}
          >
            <Skeleton
              variant='rounded'
              height={36}
              width='80%'
            />
            <Skeleton
              variant='rounded'
              height={36}
              width='90%'
            />
            <Skeleton
              variant='rounded'
              height={36}
              width='70%'
            />
          </Stack>
        ) : (
          <RadioGroup value={value}>
            <FormControlLabel
              disabled={loading}
              value='default'
              control={
                <Radio
                  onChange={onUseDefault}
                  disabled={loading}
                />
              }
              label={t('bulkInvite.useDefault', 'Use Default Invitation')}
            />
            <FormControlLabel
              disabled={loading}
              value='custom'
              control={
                <Radio
                  onChange={onUseCustomized}
                  disabled={loading}
                />
              }
              label={t(
                'bulkInvite.useCustomized',
                'Use my own customized Invitation',
              )}
            />
            <FormControlLabel
              disabled={loading || !hasSavedOptions}
              value='saved'
              control={
                <Radio
                  onChange={onUseSaved}
                  disabled={loading || !hasSavedOptions}
                />
              }
              label={t('bulkInvite.useSaved', 'Use custom saved Invitation')}
            />
          </RadioGroup>
        )}
      </Box>
    </Stack>
  );
};

export default InvitationTypeSelector;
